import { environment } from "src/environments/environment";
import { CategoryData } from "./interfaces/categoryData";
import { RequestKeys } from "./enums/request-keys.enum";
import { EntityType } from "./enums/entity-type.enum";
import { TabId } from "./enums/tab-id.enum";
import { MultiLangStrDto } from "./models/multi-lang-str-dto";
import { PageItem } from "./components/module-header/header-interfaces";
// import { PageItem } from "@iaa-main-org/module-header";
import { MaxLengthValidator } from "@angular/forms";

export const SMALL_SCREEN_WIDTH = 1400;

export const THESAURUS_URL = environment.backendUrl + '/thesaurus';
export const REGIONS_URL = environment.backendUrl + '/regions';
export const SETTLEMENT_URL = environment.backendUrl + '/settlements';
export const EXPEDITIONS_URL = environment.backendUrl + '/expeditions';
export const EXCAVATIONS_URL = environment.backendUrl + '/excavations';
export const SURVEYS_URL = environment.backendUrl + '/surveys';
export const HACHRAZOT_URL = environment.backendUrl + '/hachrazot';
export const LICENSES_URL = environment.backendUrl + '/licenses';
export const HERITAGE_SITES_URL = environment.backendUrl + '/heritage-sites';
export const PERIODS_URL = environment.backendUrl + '/periods';
export const FIND_TYPE_URL = environment.backendUrl + '/findTypes';
export const THESAURUS_ALL_URL = environment.backendUrl + '/thesaurus-all';
export const MATERIAL_URL = environment.backendUrl + '/materials';
export const ENTITY_TYPE_URL = environment.backendUrl + '/entity-types';
export const ENTITIES_LOCI_URL = environment.backendUrl + '/entities/loci';
export const ENTITIES_URL = environment.backendUrl + '/entities';
export const LOCUS_DETAILS_URL = environment.backendUrl + '/locus';
export const HACHRAZA_DETAILS_URL = environment.backendUrl + '/hachraza';
export const MANUSCRIPT_DETAILS_URL = environment.backendUrl + '/entities/manuscript';
export const DANA_PDF_URL = environment.backendUrl + '/dana-files';
export const DECISION_LETTERS_URL = environment.backendUrl + '/decision-letters';
export const MEDIA_VIEW_URL = '/media/view';
export const SEARCH_URL = environment.backendUrl + '/query';
export const UNIFIED_MODULES_URL = environment.backendUrl + '/config/modules';
export const LANGUAGE_CONFIG_URL = environment.backendUrl + '/config/languages';
export const ARCHIVE_URL = environment.backendUrl + '/scientific-archive'
export const ARCHIVE_FOLDER_URL = environment.backendUrl + '/scientific-archive/folder'
export const CONSERVATION_ARCHIVE_URL = environment.backendUrl + '/conservation-archive'
export const CONSERVATION_ARCHIVE_FOLDER_URL = environment.backendUrl + '/conservation-archive/folder'
export const PERSONS_URL = environment.backendUrl + '/persons';
export const DECISIONS_URL = environment.backendUrl + '/decisions';
export const ID_URL = environment.backendUrl + '/id';

export const DEFAULT_PAGE_ID = 0;
export const DEFAULT_ENTITY_INDEX = 0;
export const PAGE_ID = 'pageId';
export const TAB_ID = 'tabId';
export const ENTITY_INDEX = 'entity_index';
export const ENTITY_ID = 'entityId';
export const ENTITY_TYPE = 'entityType';

export const TAB_LABLES = {
  YAZAM: 'דו"ח ליזם',
  ARCHAELOGICAL_SEARCH: 'מאגר ארכיאולוגי',
}
export const ROLES = {
  EDIT : 'edit',
  APPROVE : 'approve',
}
export const PAGES: PageItem[] = [
  {id: 0, name: 'search', link: 'search', sourceText:'iaa.moduleHeader.search', text: ''},
]
export const INFO_PAGES = [
  {id: 4, name: 'accessibility', link: 'accessibility', sourceText:'iaa.moduleHeader.accessibility' ,text: '', sourceAriaLabelText:'iaa.aria.accessibilityAriaLabel', ariaLabelText:''},
  {id: 2, name: 'about', link: 'about',sourceText:'iaa.moduleHeader.about', text: '', sourceAriaLabelText:'iaa.aria.aboutAriaLabel', ariaLabelText:''},
  {id: 1, name: 'terms', link: 'terms',sourceText:'iaa.moduleHeader.terms', text: '', sourceAriaLabelText:'iaa.aria.termsAriaLabel', ariaLabelText:''},
  {id: 5, name:'privacy', link: 'privacy',sourceText:'iaa.moduleHeader.privacy', text:'', sourceAriaLabelText:'iaa.aria.privacyAriaLabel', ariaLabelText:''},
  {id: 6, name:'software', link: 'software',sourceText:'iaa.moduleHeader.creditSoftware', text:'', sourceAriaLabelText:'iaa.aria.creditSoftwareAriaLabel', ariaLabelText:''},
]
// top of results names
export const ENTITY_TYPE_SHORT: { [key: string]: MultiLangStrDto } = {
  basket: new MultiLangStrDto ("סלים (DANA)","Baskets (Dana)"),
  expedition:new MultiLangStrDto ( "משלחות  חפירה"," Excavation Expeditions"),
  survey: new MultiLangStrDto ( "סקרים","Surveys"),
  excavation:new MultiLangStrDto ( "חפירות","Excavations"),
  conservation_report:new MultiLangStrDto ( "דוחות שימור מסכמים ","Conservation Summary Reports"),
  hachraza:new MultiLangStrDto("אתרי עתיקות מוכרזים","Declared Archaeological Sites"),
  license: new MultiLangStrDto ("רישיונות חפירה"," Excavation Licenses/Permits"),
  locus: new MultiLangStrDto("לוקוסים (DANA)","Loci (Dana)"),
  object: new MultiLangStrDto("פריטים באוצרות המדינה","National Treasure's Artifacts"),
  publication: new MultiLangStrDto("פרסומי רשות העתיקות","IAA publications"),
  photogrammetric_model: new MultiLangStrDto("מודלים תלת-מימדיים","3D Models"),
  orthophoto: new MultiLangStrDto("אורטופותואים","Orthophotos"),
  yazam_report:new MultiLangStrDto("דוחות ליזם","Yazam Reports"),
  scientific_archive_documents:new MultiLangStrDto("מסמכי ארכיון מדעי","Scientific Archive Files"),
  scientific_archive_folders:new MultiLangStrDto("תיקיות ארכיון מדעי ","Scientific Archive Folders"),
  conservation_archive_documents:new MultiLangStrDto("מסמכי ארכיון שימור","Conservation Archive Documents"),
  conservation_archive_folders:new MultiLangStrDto("תיקיות ארכיון שימור","Conservation Archive Folders"),
  person :new MultiLangStrDto("חוקרים","Researchers"),
  decision_letters :new MultiLangStrDto("מכתבי החלטה לבדיקת תכניות","Decision Letters"),
  fragment:new MultiLangStrDto("קטעים ממגילות מדבר יהודה","Dead Sea Scroll Fragments"),
  dana_pdf:new MultiLangStrDto("תיקי חפירה דיגיטליים","Excavation Digital Archaeological Documents"),
  manuscript: new MultiLangStrDto("מגילות מדבר יהודה","Dead Sea Scrolls"),
  coin: new MultiLangStrDto("מטבעות","Coins"),
  plaster_sample:new MultiLangStrDto("דגימות מעבדה","Lab Samples"),
  hb_section:new MultiLangStrDto("חתכי בדיקה","Test Sections")
};
// in each result box
export const ENTITY_TYPE_NAMES: { [key: string]: MultiLangStrDto } = {
  basket: new MultiLangStrDto ("סלים (DANA)","Baskets (Dana)"),
  expedition:new MultiLangStrDto ( "משלחות  חפירה"," Excavation Expeditions"),
  excavation:new MultiLangStrDto ( "חפירות","Excavations"),
  survey: new MultiLangStrDto ( "סקרים","Surveys"),
  conservation_report:new MultiLangStrDto ( "דוחות שימור מסכמים","Conservation Summary Reports"),
  hachraza:new MultiLangStrDto("אתרי עתיקות מוכרזים","Declared Archaeological Sites"),
  license: new MultiLangStrDto ("רישיונות חפירה"," Excavation Licenses/Permits"),
  locus: new MultiLangStrDto("לוקוסים (DANA)","Loci (Dana)"),
  object: new MultiLangStrDto("פריטים באוצרות המדינה","National Treasure's Artifacts"),
  publication: new MultiLangStrDto("פרסומי רשות העתיקות","IAA publications"),
  photogrammetric_model: new MultiLangStrDto("מודלים תלת-מימדיים","3D Models"),
  orthophoto: new MultiLangStrDto("אורטופוטו","Orthophotos"),
  yazam_report:new MultiLangStrDto("דוחות ליזם","Yazam Reports"),
  scientific_archive_documents:new MultiLangStrDto("מסמכי ארכיון מדעי","Scientific Archive Files"),
  scientific_archive_folders:new MultiLangStrDto("תיקיות ארכיון מדעי ","Scientific Archive Folders"),
  conservation_archive_documents:new MultiLangStrDto("מסמכי ארכיון שימור","Conservation Archive Documents"),
  conservation_archive_folders:new MultiLangStrDto("תיקיות ארכיון שימור","Conservation Archive Folders"),
  person :new MultiLangStrDto("חוקרים","Researchers"),
  decision_letters :new MultiLangStrDto("מכתבי החלטה לבדיקת תכניות","Decision Letters"),
  fragment:new MultiLangStrDto("קטעים ממגילות מדבר יהודה","Dead Sea Scroll Fragments"),
  manuscript: new MultiLangStrDto("מגילות מדבר יהודה","Dead Sea Scrolls"),
  dana_pdf:new MultiLangStrDto("תיקי חפירה דיגיטליים","Excavation Digital Archaeological Documents"),
  coin: new MultiLangStrDto("מטבעות","Coins"),
  plaster_sample:new MultiLangStrDto("דגימות מעבדה","Lab Samples"),
  hb_section:new MultiLangStrDto("חתכי בדיקה","Test Sections")
};

export const FILTERABLE_FIELDS: string[] = [
  'licensesString',
  'thesaurusByLanguage',
  'descriptionText',
  'titleText',
  'nameByLanguage'];

  export const RESULTS_TABS = [
    TabId.LIST,
    TabId.TABLE,
    TabId.MAP,
  ]


export const ENTITY_TYPE_TO_TAB_ID: { [key in EntityType]?: TabId } = {
  [EntityType.LOCUS]: TabId.LOCUS,
  [EntityType.BASKET]: TabId.LOCUS,
  [EntityType.OBJECT]: TabId.OBJECT,
  [EntityType.HACHRAZA]: TabId.HACHRAZA,


};

export const MENU_CATEGORIES: Array<CategoryData> = [
    {id: 0, icon: "assets/search-icon.svg", link: 'search'},
    {id: 1, icon: "assets/contact-icon.svg", link: 'contact'},
    {id: 2, icon: "assets/about-icon.svg", link: 'about'},
  ]

  export const ENTITY_MENU_CATEGORIES = [
    {label: 'פרטים', icon: 'pi pi-book'},
    {label: 'מפה', icon: 'pi pi-map'},
  ]
export const RESULTS_TABLE_COLUMNS = [
  {field: 'nameByLanguage', header: new MultiLangStrDto('מקור','Source'), sortable: true,filterable: FILTERABLE_FIELDS.includes('nameByLanguage')},
  {field: 'title', header: new MultiLangStrDto('כותרת','Title'), sortable: true, filterable: FILTERABLE_FIELDS.includes('titleText')},
  {field: 'thesaurusByLanguage', header: new MultiLangStrDto('מונחים', 'Terms'), sortable: true, filterable: FILTERABLE_FIELDS.includes('thesaurusByLanguage')},
  {field: 'description', header: new MultiLangStrDto( 'פירוט','Details'), sortable: true, filterable: FILTERABLE_FIELDS.includes('descriptionText')},
  {field: 'licensesString', header: new MultiLangStrDto('רשיונות','Licenses'), sortable: true, filterable: FILTERABLE_FIELDS.includes('licensesString')},
  {field: 'shapes', header: new MultiLangStrDto('מפה','Map'),styleClass: 'header-col-small', sortable: false, filterable: FILTERABLE_FIELDS.includes('shapes')},
  {field: 'menu', header: new MultiLangStrDto('',''), styleClass: 'header-col-x-small', sortable: false, filterable: false},
  {field: 'entityId', header: new MultiLangStrDto('Entity Id','Entity Id'), styleClass: 'header-col', sortable: false, filterable: true},
];
export const UNAUTHORIZED_TABLE_COLUMNS = [
  {field: 'license', header: 'רשיון', styleClass: 'header-col'},
  {field: 'expedition', header: 'משלחת', styleClass: 'header-col'},
]
export const FIELD_MAPPING: Record<RequestKeys, { id: string, label: string }> = {
  [RequestKeys.THESAURUS_WIDS]: { id: 'wid', label: 'wordName' },
  [RequestKeys.ADVANCED_THESAURUS]: { id: 'data', label: 'multiLangLabel' },
  [RequestKeys.CONSERVATION_REPORTS]: { id: 'id', label: 'name' },
  [RequestKeys.PERIOD_MIDS]: { id: 'data', label: 'multiLangLabel' },
  [RequestKeys.FIND_TYPE_MIDS]: { id: 'data', label: 'multiLangLabel' },
  [RequestKeys.PERSONS]: { id: 'entityPersonId', label: 'name' },
  [RequestKeys.LICENSES]: { id: 'licenseId', label: 'longName' },
  [RequestKeys.EXPEDITIONS]: { id: 'expeditionId', label: 'expeditionName' },
  [RequestKeys.EXPEDITION_LICENSES]: { id: 'licenseId', label: 'longName' },
  [RequestKeys.EXCAVATIONS]: { id: 'excavationId', label: 'excavationName' },
  [RequestKeys.EXCAVATION_LICENSES]: { id: 'licenseId', label: 'longName' },
  [RequestKeys.SURVEYS]: { id: 'entitySurveyId', label: 'surveyName' },
  [RequestKeys.SURVEY_LICENSES]: { id: 'licenseId', label: 'longName' },
  [RequestKeys.HACHRAZOT]: { id: 'hachrazaEntityId', label: 'name' },
  [RequestKeys.REGION_IDS]: { id: 'id', label: 'name' },
  [RequestKeys.SETTLEMENT_IDS]: { id: 'id', label: 'name' },
  [RequestKeys.REGIONS]: { id: 'id', label: 'name' },
  [RequestKeys.MATERIAL_MIDS]: { id: 'data', label: 'multiLangLabel' },
  [RequestKeys.ENTITY_TYPES]: { id: 'id', label: 'entityTypeName' },
  [RequestKeys.FREE_TEXT]: { id: 'id', label: 'label' },
  [RequestKeys.HERITAGE_SITE_IDS]: { id: 'data', label: 'multiLangLabel' }
};
